<div class="single-similar-job-container bg-white py-6 px-4 mb-4" *ngFor="let similarJob of similarJobData">
    <div class="row">
        <div class="col-md-2">
            <div class="photo-box">
                <a href="/job/{{similarJob.id}}">
                    <img src="{{similarJob.photoPath}}" class="img-fluid job-logo" alt="Job Logo">
                </a>
            </div>
        </div>
        <div class="col-md-8">
            <h5 class="custom-section-title">
                <a class="job-link" href="/job/{{similarJob.id}}">{{similarJob.jobTitle}}</a></h5>
            <ul class="list-unstyled">
                <li>
                    <i class="icofont-location-pin blue-color"></i><span>{{similarJob.country}}
                    , {{similarJob.city}}</span>
                </li>
                <li>
                    <i class="icofont-notepad blue-color"></i>
                    <span [innerHTML]="(similarJob.jobDescription.length > 50) ? (similarJob.jobDescription | slice:0:50) + '...' : (similarJob.jobDescription)"></span>
                </li>
                <li>
                    <i class="icofont-calendar blue-color"></i>
                    <span>Data Postare: {{similarJob.jobPostingDate | date: "dd-MM-yyyy"}}</span>
                </li>
                <li>
                    <i class="icofont-calendar blue-color"></i>
                    <span>Expira la: {{similarJob.jobEndingDate | date: "dd-MM-yyyy"}}</span>
                </li>
            </ul>
        </div>
        <div class="col-md-2 d-flex align-items-center">
            <a class="work-type"
               [ngClass]="{
                'green-background': similarJob.workType === 'volunteer',
                'blue-background': similarJob.workType === 'practice',
                'yellow-background': similarJob.workType === 'internship',
                'tryan-purple': similarJob.workType === 'project',
                'orange-background': similarJob.workType === 'temporary',
                'verdigris': similarJob.workType === 'part_time',
                'purple-heart ': similarJob.workType === 'full_time',
                'darkgreen-background': similarJob.workType === 'remote'}">
                {{similarJob.workType | enumTransform}}
            </a>
        </div>
    </div>
</div>
